import React from 'react';
import PropTypes from 'prop-types';
import Input from '@client/components/formComponents/input/Input';
import styles from './styles.scss';

const InputGroup = React.memo(
  ({
    className,
    inputClassName,
    formLabelClassName,
    errorTextClassName,
    labelText,
    name,
    value,
    onChange,
    onBlur,
    autoComplete,
    isDisabled,
    readOnly,
    type,
    tabIndex,
    defaultValue,
    errorLabel,
    placeholder,
    maxLength,
    size = 1,
  }) => {
    return (
      <div
        className={`${styles.inputGroup}${className ? ` ${className}` : ''}`}
        style={{
          flex: `${size} 1 0%`,
        }}
      >
        <label
          className={`${styles.formLabel}${
            formLabelClassName ? ` ${formLabelClassName}` : ''
          }`}
        >
          {labelText}
        </label>
        <Input
          placeholder={placeholder}
          className={`${inputClassName}`}
          disabled={isDisabled}
          readOnly={readOnly}
          autoComplete={autoComplete}
          type={type}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          defaultValue={defaultValue}
          tabIndex={tabIndex}
          maxLength={maxLength}
        />
        {errorLabel && (
          <span
            className={`${styles.errorText}${
              errorTextClassName ? ` ${errorTextClassName}` : ''
            }`}
          >
            {errorLabel}
          </span>
        )}
      </div>
    );
  }
);

InputGroup.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  formLabelClassName: PropTypes.string,
  errorTextClassName: PropTypes.string,
  labelText: PropTypes.string,
  name: PropTypes.string,
  isDisabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.string,
  autoComplete: PropTypes.string,
  type: PropTypes.string,
  tabIndex: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errorLabel: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  size: PropTypes.string,
};

InputGroup.displayName = 'InputGroup';

export default InputGroup;
